import uuid from 'uuid'
import KokosilClientInterface from './kokosil-client-interface'
import { getStorageAvailable, getStorageItem, setStorageItem } from './local-storage'

const STORAGE_KEY_NAME = 'katsushika.chatbot'

const USER_ID = 'user_id'
const MESSAGES = 'messages'

const STORAGE_UNAVAILABLE_USER_ID = '__storage_unavailable__'
export const TEST_USER_ID = '__test_user__'

// デフォルト値
const userData = {
  // メッセージ
  // * IDごとに配列で保持
  [MESSAGES]: {},
}

const saveUserData = () => setStorageItem(STORAGE_KEY_NAME, JSON.stringify(userData))

// window.KokosilClientInterfaceを待つ
const resolved = () => {
  // ユーザーID
  // * ストレージが使えないユーザーとテストユーザーは別扱いとする。
  updateUserData(USER_ID, getStorageAvailable() ? uuid.v4() : STORAGE_UNAVAILABLE_USER_ID)

  if (getStorageAvailable()) {
    const json = getStorageItem(STORAGE_KEY_NAME)
    if (json) {
      // デフォルト値をストレージ内容で上書き
      Object.assign(userData, JSON.parse(json))

      // 古いメッセージを削除(1日)
      const d0 = new Date()
      d0.setDate(d0.getDate() - 1)
      const messages = userData[MESSAGES]
      Object.keys(messages).forEach((categoryId) => {
        const filteredMessages = messages[categoryId].filter((message) => new Date(message.createdAt) > d0)
        updateUserData(MESSAGES, Object.assign(messages, { [categoryId]: filteredMessages }))
      })
      saveUserData()
    } else {
      // 初回保存
      saveUserData()
    }
  }
}
const rejected = () => {}
KokosilClientInterface
  .wait()
  .then(resolved, rejected)

const updateUserData = (key, value) => {
  Object.assign(userData, { [key]: value })
}

// ユーザーID
export const getUserDataUserId = () => userData[USER_ID]
export const setUserDataUserId = (value) => {
  updateUserData(USER_ID, value)
  saveUserData()
}

// メッセージ
export const getUserDataMessages = (categoryId) => userData[MESSAGES][categoryId] || []
export const setUserDataMessages = (categoryId, messages) => {
  updateUserData(MESSAGES, Object.assign(userData[MESSAGES], { [categoryId]: messages }))

  // 保存
  saveUserData()
}
